const _ = require('lib/underscore')
const log = require('log').create('isAllowedFeature') // eslint-disable-line

module.exports = function isAllowedFeature(user, feature) {
    return _.contains(user.allowed_features, feature)
}
